module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('li', {
    staticClass: "hidden-folded padder m-t m-b-sm text-muted text-xs"
  }, [_c('span', [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))]
  })], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ca67625","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/MenuTitle.vue
// module id = 1979
// module chunks = 18